export default "__VITE_ASSET__h$FeqcNZ__"